import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { Divider, Stack } from '@mui/material';
import { SUPPORTED_CURRENCIES } from 'legacyfrontend/contexts/FlightsFiltersContext';
import { AccordionSection } from './AccordionSection';
import { ToggleSwitch } from './ToggleSwitch';

export const CurrencyFilter = ({
  dropdownState,
  toggleDropdown,
  currency,
  handleCurrencyChange,
  background,
}) => {
  return (
    <Stack gap={2}>
      <AccordionSection
        isOpen={dropdownState.currency}
        onToggle={() => toggleDropdown('currency')}
        title='Moneda'
      >
        <Stack gap={2}>
          {SUPPORTED_CURRENCIES.map((currencyCode) => (
            <ToggleSwitch
              background={background}
              icon={AttachMoneyIcon}
              isActive={currency === currencyCode}
              key={currencyCode}
              label={currencyCode}
              onChange={() => handleCurrencyChange(currencyCode)}
            />
          ))}
        </Stack>
      </AccordionSection>
      <Divider />
    </Stack>
  );
};
